export const resolveAdminAssignmentBadgeTone = (assignedCount) => {
  if (assignedCount == null) return 'alert';
  const normalizedCount = Number(assignedCount);
  if (!Number.isFinite(normalizedCount)) return 'alert';
  return normalizedCount === 0 ? 'ok' : 'alert';
};

export const resolveAdminAssignmentBadgeToneClass = (assignedCount) =>
  `sidebar-count-badge--${resolveAdminAssignmentBadgeTone(assignedCount)}`;

export const buildAdminAssignmentBadge = ({ totalCount, assignedCount } = {}) => {
  const normalizedTotal = Number(totalCount);
  if (!Number.isFinite(normalizedTotal) || normalizedTotal <= 0) {
    return { count: 0, tone: null };
  }
  return {
    count: Math.floor(normalizedTotal),
    tone: resolveAdminAssignmentBadgeTone(assignedCount),
  };
};
